<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-sm-12 ">
        <div class="">
          <div class="x_panel">
            <h2 class="float-left"> Job Planner Report </h2>
            <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
              <button v-if="isPermissionExist(PERMISSIONS.JOB_PLANNER_REPORT_PRINT)" @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                <i class="fa fa-print" v-if="!isPrinting"></i>
                <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                {{ isPrinting ? 'Printing...' : 'Print' }}
              </button>
            <vue-excel-xlsx
              v-if="isPermissionExist(PERMISSIONS.JOB_PLANNER_REPORT_PRINT)"
              ref="excel"
              :data="excelData"
              :columns="excelHeader"
              :file-name="'Job Planner Report'"
              :file-type="'xlsx'"
              :sheet-name="'sheetname'"
              :disabled="isPrinting"
              class="btn btn-primary btn-sm float-right"
            >
              <div
                @click.prevent="handleExportPrint('excel')"
              >
                <i class="fa fa-file-excel-o"></i>
                {{ isPrinting ? 'Preparing...' : 'Excel' }}
              </div>
            </vue-excel-xlsx>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <select class="form-control" v-model="form.vessel">
            <option value="" selected>Select Vessel</option>
            <option v-for="(row, key) in vessels" :value="row?.id">{{row?.name}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <DatePicker type="date" v-model="form.date" placeholder="Enter Date Range" valueType="format" range></DatePicker>
      </div>
      <div class="col-md-2" v-if="isPermissionExist(PERMISSIONS.MAINTENANCE_ASSIGNED_RANKED)">
        <div class="form-group">
          <select v-model="form.rank_fixed" class="form-control">
            <option value="">Select Rank</option>
            <option v-for="role in roles" :key="role?.id" :value="role?.id">{{role?.name}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <select class="form-control" v-model="form.critical_jobs">
            <option value>Select Critical Jobs</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>
      </div>

      <div class="col-md-2">
        <div class="form-group">
          <select class="form-control" v-model="form.critical_component">
            <option value>Select Critical Components</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn btn-sm btn-info" @click="getAllPeandingJob">Search</button>
      </div>
      <div class="col-md-7"></div>

    </div>
    <div>
      <div v-if="type=='pending'">
        <div class="row">
          <div class="col-md-12">
            <h4 class="text-center mt-4"> Job Planner Report </h4>
            <span></span>
          </div>
        </div>
        <div
          v-if="loading"
          class="col-md-12 text-center"
          style="margin-top:25%"
        >
          <PulseLoader
            :loading="loading"
          ></PulseLoader>
        </div>
        <div v-if="!loading" class="row">
          <div class="col-md-12">
<!--            <PerPageSelector v-model="offset" @change="onPerPageChange"/>-->
            <div class="table-responsive">
              <TableData :jobList="jobList"/>
<!--              <Pagination :pagination="jobList" :getData="getAllPeandingJob"/>-->

              <div id="printArea" style="display: none">
                <div style="text-align: center;line-height: 20px;">
                  <h2 style="line-height: 10px;">{{ appName }}</h2>
                  <div style="line-height: 10px;" class="font-weight-bold">Job Planner Report</div>
                  <p style="line-height: 10px;" v-if="form.date"> From {{form?.date[0]}} To {{form?.date[1]}}</p>
                  <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                </div>
                <TableData :jobList="printItems" :isPrinting="true"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import auth from '../../../auth'
    import TableData from "./TableData.vue";
    import {apiPrintData, printUtil} from "@/utils/print";
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import exportMixin from "@/mixin/exportMixin";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import permissionsMixin from "@/mixin/permissionsMixin";

    export default {
        mixins: [printMixin, goBackButtonMixin, exportMixin,permissionsMixin],
        name: 'JobPlanner',
        components: {TableData, DatePicker, PulseLoader},
        data() {
            return {
                loading: false,
                appName: process.env.VUE_APP_NAME,
                editMode: false,
                isPrinting: false,
                query: '',
                queryFiled: 'name',
                permissions: auth.getPermissionData(),
                vessels: null,
                offset: 20,
                counteryes: [],
                printItems: [],
                roles: [],
                form: new Form({
                    date: '',
                    vessel: auth.getVesselId(),
                    rank_fixed:'',
                    critical_jobs:'',
                    critical_component:'',
                }),
                pagination: {
                    current_page: 1
                },
                i: 0,
                jobList: [],
                type: 'pending',
                vesselId: auth.getVesselId(),
                user_type: auth.getUserType(),
                excelHeader: [],
                excelData: []
            }
        },
        mounted() {
            this.getVessel();
            this.getAllPeandingJob();
            this.allRole();
        },
        methods: {
          allRole() {
            this.$http.get("/api/filter/get-active-role").then(response => {
              this.roles = response.data.success;
            }).catch(e => {
              console.log(e);
            });
          },

          onPerPageChange() {
            this.getAllPeandingJob(1);
          },

          prepareExportData(jobList) {
            let rows = [];
            if (!jobList || !jobList) return rows;

            jobList.forEach(job => {
              if (!job.job_schedules || !job.job_schedules.length) return;
              job?.job_schedules.forEach(schedule => {
                rows.push({
                  'Job Name(Code)': `${job?.name || ''} (${job?.code || ''})`,
                  'Department(Code)': `${job?.department?.name || ''} (${job?.department?.code || ''})`,
                  'Main Component Name': `${job?.main_component?.name || ''} (${job?.main_component?.code || ''})`,
                  'Last Maintenance Date': schedule?.start_date || '',
                  'Due Date': job?.end_date || '',
                  'Counter Type': job?.counter_type || '',
                  'Status': schedule.status,
                  'Assigned Ranked': job?.rank_fixed_role?.name
                });

              });
            });

            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return false;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
            return true;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              let params = {
                date: this.form.date,
                vessel_id: this.form.vessel,
                rank_fixed: this.form.rank_fixed,
                critical_jobs: this.form.critical_jobs,
                critical_component: this.form.critical_component,
                is_all: 1,
              };

              const res = await this.$http.get('/api/get-pending-job-report', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Job Planner Report');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },

            getAllPeandingJob(page = 1) {
                this.loading = true;
                let params = {
                    date: this.form.date,
                    vessel_id: this.form.vessel,
                    rank_fixed: this.form.rank_fixed,
                    critical_component: this.form.critical_component,
                    critical_jobs: this.form.critical_jobs,
                    is_all: 1,
                    offset: this.offset,
                    page: page
                };
                this.$http.get('/api/get-pending-job-report', {params}).then(response => {
                    this.jobList = response?.data?.success;
                    this.loading = false;
                }).catch(e => {
                    console.log(e);
                    this.loading = false;
                    let response = e.response;
                    if (response?.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else {

                    }
                })
            },

            getAllOverDueJob() {
                this.$http.get('/api/get-due-job/' + this.vesselId + '/List').then(response => {
                    this.jobList = response.data.success
                }).catch(e => {
                    console.log(e)
                })
            },
            getAllDeferJob() {
                this.$http.get('/api/get-defer-job/' + this.vesselId + '/List').then(response => {

                    this.deferJob = response.data.success
                }).catch(e => {
                    console.log(e)
                })
            },
            getAllDoneJob() {
                this.$http.get('/api/get-done-job/' + this.vesselId + '/List').then(response => {
                    this.jobListDone = response.data.success
                }).catch(e => {
                    console.log(e)
                })
            },
            getVessel() {
            let params = {
              is_all: 1
            }
                this.$http.get('/api/vessel', {params}).then(response => {
                    this.vessels = response.data.success.vessel
                }).catch(e => {
                    console.log(e)
                })
            },

        }
    }
</script>

<style scoped>
  .mx-datepicker-range {
    width: 100%;
  }
</style>
